import React from "react";
import { useDialog } from "./DialogProvider";
import MissingDialog from "./MissingDialog";

const GlobalMissingDialog = () => {
    const { dialogType, dialogData, hideDialog } = useDialog();

    if (dialogType !== "paymentComments") return null;

    return <MissingDialog toggle={hideDialog} {...dialogData} />;
};

export default GlobalMissingDialog;
